import { useQuery } from "@tanstack/react-query";

import ProjectsService from "@/services/ProjectsService";
import ViewsService from "@/services/ViewsService";

import { analyticsKeys } from "@/constants/CQueryKeys";

import { TOverviewPeriod } from "@/types";

/**
 * A page's figures in one query. Keyed under "analytics" so the task,
 * project and view mutations that invalidate the analytics keys
 * refresh these too. No period = the current month, server side.
 */
export const useProjectOverview = (id: number, period: TOverviewPeriod = {}) =>
	useQuery({
		queryKey: analyticsKeys.projectOverview(id, period),
		queryFn: () => ProjectsService.getOverview(id, period),
		enabled: Number.isInteger(id) && id > 0,
	});

export const useViewOverview = (id: number, period: TOverviewPeriod = {}) =>
	useQuery({
		queryKey: analyticsKeys.viewOverview(id, period),
		queryFn: () => ViewsService.getOverview(id, period),
		enabled: Number.isInteger(id) && id > 0,
	});
